// extracted by mini-css-extract-plugin
export default {"review-card":"ReviewCard_review-card__teXD5","name":"ReviewCard_name__bLa6Y","paragraph":"ReviewCard_paragraph__1fVGj","name-tag":"ReviewCard_name-tag__eC5BA"};